export const IDEA_TITLE_LIMIT = 120;
export const ADD_IDEA_MAX_LENGTHS = {
  title: 100,
  introduction: 500,
  problem: 2500,
  opportunity: 2500,
  supportingUrlTitle: 100,
};
export const TENANT_ID = 1;
export const BUILT_LINKEDIN_URL =
  'https://www.linkedin.com/company/built-company';
export const ALUMNI = 1;
export const FACULTY = 2;
export const SPONSOR = 3;
export const STAFF = 4;
export const ADMIN = 5;
export const SUPPORT_EMAIL = 'support@thebuilt.co';
export const GMAIL_URL = 'https://mail.google.com/mail';
export const CHECK_SESSION_EXPIRATION_TIME = 10000;
export const ID_TOKEN_EXPIRATION_TIME_IN_SECONDS = 60 * 60; // id token expiration time
export const REFRESH_TOKEN_EXPIRATION_TIME_IN_SECONDS = 30 * 24 * 60 * 60; // refresh token expiration 30 * 24 * 60 * 60 for 30 days
export const PENDING = 1;
export const APPROVED = 2;
export const REJECTED = 3;
